import { render, staticRenderFns } from "./BcSelect.vue?vue&type=template&id=22348f54"
import script from "./BcSelect.vue?vue&type=script&lang=js"
export * from "./BcSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports